/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readability Analyzer — Flesch Reading Score | Toolverse`)
};

const es_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizador de Legibilidad — Puntuación Flesch Reading Ease | Toolverse`)
};

const de_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesbarkeitsanalyse — Flesch-Lesewert | Toolverse`)
};

const nl_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leesbaarheidsanalisator — Flesch Reading Score | Toolverse`)
};

const fr_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseur de lisibilité — Score Flesch | Toolverse`)
};

const it_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizzatore di Leggibilità — Punteggio Flesch Reading | Toolverse`)
};

const pt_br2_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisador de Legibilidade — Pontuação de Leitura Flesch | Toolverse`)
};

const pt_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisador de Legibilidade — Pontuação Flesch Reading | Toolverse`)
};

const ja_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読みやすさ分析ツール — Flesch Reading Score | Toolverse`)
};

const zh_ra_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可读性分析工具 — Flesch 阅读分数 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_meta_title", locale)
	if (locale === "en") return en_ra_meta_title(inputs)
	if (locale === "es") return es_ra_meta_title(inputs)
	if (locale === "de") return de_ra_meta_title(inputs)
	if (locale === "nl") return nl_ra_meta_title(inputs)
	if (locale === "fr") return fr_ra_meta_title(inputs)
	if (locale === "it") return it_ra_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ra_meta_title(inputs)
	if (locale === "pt") return pt_ra_meta_title(inputs)
	if (locale === "ja") return ja_ra_meta_title(inputs)
	return zh_ra_meta_title(inputs)
};